import { useEffect, useState } from "react";

import { PlatformDTO } from "@app/api/generated";
import { getPlatformById } from "@app/modules/product-page-sync/product-page-sync-api";

/**
 * Loads a platform's sync config (grace period + min-deal thresholds) once per id, for the
 * run-detail status tooltips. Returns `null` until it resolves or on failure — callers fall back to
 * a generic, number-less explanation in that case.
 */
export const usePlatform = (platformId: number): PlatformDTO | null => {
  const [platform, setPlatform] = useState<PlatformDTO | null>(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const result = await getPlatformById(platformId);
        if (active) {
          setPlatform(result);
        }
      } catch {
        if (active) {
          setPlatform(null);
        }
      }
    })();
    return () => {
      active = false;
    };
  }, [platformId]);

  return platform;
};
